import React from "react"
import {RefTable, DefaultProps} from "../RefTable"

export const Currency = (props)=><RefTable {...props}/>;

Currency.defaultProps = {
    ...DefaultProps,
    title: "Currency Information",
    tableSchema: "currency",
    tableName: "currency",
    edit: true,
    theadHeight: 64
}
